export const normalizeItem = (values) => {
    const { departure, time } = values.journey;
    const { journeys, ...arrival } = values.journey.arrival;
    const journey = journeys[time];

    return {
        date: values.date,
        people: parseInt(values.people),
        from: departure,
        to: arrival,
        hour: time,
        arrivalHour: journey.time.arrival,
        price: journey.time.price,
        lineId: journey.lineId,
        driverComment: null
    };
};
